module.exports = __webpack_public_path__ + "static/step-1-fffbe89cdf4a623e4a9eef3eb6a88236.svg";